import React from 'react';
import { NavLink } from 'react-router-dom';

const AddEmployeeroleCrumb = () => (
  <NavLink to="/admin/Employeeroles/add">Add Employee Role</NavLink>
);

export default AddEmployeeroleCrumb;
